import $http from "../../axios";
import { Notification } from "element-ui";


export async function fetchContacts({ commit, state }, requestParameters = { params: state.paramsquery }) {
  await $http.get('/api/terceros', requestParameters)
    .then((response) => {
      commit('setContacts', response.data.data.data)

    })
    .catch((error) => {
      Notification.error({
        title: 'Error!',
        message: error.message,
        type: 'error',
        duration: 1500,
        customClass: 'notification-box',
      });
    })
}

export async function getTransactions({ state, commit }, id) {
  await $http.get("/api/transacciones-cartera/" + id, { params: state.params })
    .then(response => {
      commit('settransactions_wallet', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function fetchLines({ dispatch, state, rootState, commit }) {
  if (!state.lines.length) {
    await dispatch('lines/fetchLines', { params: { paginate: false } }, { root: true })
    commit('setLines', rootState.lines.lines)
  }
}

export async function getOrders({ state, commit }, id) {
  state.params.product_id=id
  await $http.get("/api/reposicion-inventario/" + id, { params: state.params })
    .then(response => {
      commit('setOrdersProduct', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getEntraces({ state, commit }, id) {
  await $http.get("/api/entradas-factura/" + id)
    .then(response => {
      commit('setEntraces', response.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getOrdersMasive({ state, commit }) {
  await $http.get("/api/reposicion-inventario-masive/", { params: state.params })
    .then(response => {
      commit('setOrdersProduct', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getProducts({ state, commit }) {

  await $http.get("/api/reposicion-inventario/", { params: state.params })
    .then(response => {
      commit('setProducts', response.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
  state.loading.products = false;
}

export async function updateProducts({ state, commit }) {
  await $http.get("/api/update-quantity-import/", { params: state.params })
    .then(response => {
      state.loading.products = false;
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getSalesMonth({ state, commit }, id) {
  await $http.get("/api/reposicion-inventario/sales/" + id, { params: state.params })
    .then(response => {
      commit('setProductSales', response.data.sales)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getBoProduct({ state, commit }, id) {
  await $http.get("/api/reposicion-inventario/bo/" + id, { params: state.params })
    .then(response => {
      commit('setBoProduct', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function fetchProviders({ commit }, filter) {
  await $http
    .get("/api/lista-proveedores", filter)
    .then(response => {
      commit("setProviders", response.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function getTransit({ state, commit }) {
  await $http.get("/api/transit", { params: state.params })
    .then(response => {
      commit('setTransit', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}
// Inserta una cantidad especifica de un producto en la orden de reposición de inventario
export async function insertQuantityOrder({ state, commit }, data) {
  await $http.post("/api/reposicion-inventario/orden/cantidad", { data: data, params: state.params })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

// Inserta la orden completa con sus filtros
export async function insertAllOrder({ state, commit }, data) {
  // state.loading.products = true;
  await $http.post("/api/reposicion-inventario/orden/completa", { data: data, params: state.params })
    .then(response => {
      console.log(response.data.data.pdf.original.data.pdf)
      commit('setPdfRoute', response.data.data.pdf.original.data.pdf)
      state.loading.products = false;
      // commit('setTransit', response.data.data)
      Notification.success({
        title: "Exito!",
        message: 'Orden Generada',
        type: "success",
        duration: 2000,
        customClass: "notification-box"
      });
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getOrderQuantity({ state, commit }) {
  await $http.get("/api/reposicion-inventario/orden/catidades", { params: state.params })
    .then(response => {
      commit('setOrderQuantity', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getEntryImport({ state, commit }, id) {
  await $http.get("/api/reposicion-inventario-masive/entradas-importacion/" + id, { params: state.params })
    .then(response => {
      commit('setEntriesImport', response.data.data)
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function updateTransit({state, commit}, data){
  await $http.put("/api/transito/actualizar", data)
    .then(response => {
      console.log(response);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 2000,
        customClass: "notification-box"
      });
    });
}

export async function getDetailMonts({state, commit}, product){
  let data = {
    params:{
      delivery_days       : state.params.delivery_days,
      product_id          : product.id,
      average_sales_month : product.average_sales_month
    }
  }
  await $http.get(`/api/detalle-meses`, data)
  .then(response => {
      commit('setDetailMonths', response.data.data.data)
  })
  .catch(error => {
    Notification.error({
      title: "Error!",
      message: error.message,
      type: "error",
      duration: 2000,
      customClass: "notification-box"
    });
  });
}

export async function closeOrder({state, commit, dispatch}, id){
  let data = {
    state : true
  }
  await $http.post(`/api/documentos/cerrar/${id}`, data)
  .then(response => {
    Notification.success({
      title: "Hecho!",
      message: response.data.message,
      type: "success",
      duration: 2000,
      customClass: "notification-box"
    });
    dispatch('getOrdersMasive')
  })
  .catch(error => {
    Notification.error({
      title: "Error!",
      message: error.message,
      type: "error",
      duration: 2000,
      customClass: "notification-box"
    });
  });
}


// WEBPACK FOOTER //
// ./src/modules/inventory-reposition/actions.js